import { RateSelectionReasonType } from '@rygen/rygen-ui/model';

export class RateSelectionReason {
  id?: number;
  shipmentId?: number;
  rateQuoteId?: number;
  rateSelectionReasonType?: RateSelectionReasonType;
  reasonComments?: string;

  constructor(opts?: Partial<RateSelectionReason>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.rateQuoteId != null) {
      this.rateQuoteId = opts.rateQuoteId;
    }
    if (opts?.rateSelectionReasonType != null) {
      this.rateSelectionReasonType = new RateSelectionReasonType(
        opts.rateSelectionReasonType,
      );
    }
    if (opts?.reasonComments != null) {
      this.reasonComments = opts.reasonComments;
    }
  }
}
